import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TicketSupply } from '../../models/ticket-model/tiket.model';

@Component({
  selector: 'app-products-colection',
  imports: [NgClass],
  templateUrl: './products-colection.html',
  styleUrl: './products-colection.css',
})
export class ProductsColection {
  @Input() supply: TicketSupply[] = [];
  @Input() small: boolean = false;

  get totalProducts(): number {
    return this.supply.reduce((sum, item) => sum + item.Quantity, 0);
  }
}
